export enum AccessIconMode {
  Bus = 'bus',
  Car = 'car',
  Plane = 'plane',
}
